export const isUKSite = process.env.GATSBY_SANITY_LOCALE === 'en-gb';

export const topLevelDomain = isUKSite ? '.co.uk' : '.com';
